// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-register-form-container {
  width: 100%;
  margin: 25px auto 0px;
  padding: 25px;
  border: 1px solid var(--color-border-gray);
  border-radius: 8px;
}

.user-register-form-container h2 {
  color: var(--color-text-dark);
  margin-bottom: 25px;
  font-family: "Lexend Deca", sans-serif;
}

.user-register-form-container .form-row {
  display: flex;
  justify-content: space-between;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(50% - 25px);
  margin-bottom: 25px;
}

.user-register-form-container .form-row .form-column {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(50% - 25px);
  display: flex;
  flex-wrap: wrap;
}

.user-register-form-container .form-row .form-column label {
  width: 100%;
  margin-bottom: 15px;
  font-family: "Lexend Deca", sans-serif;
  color: var(--color-text-dark);
}

.user-register-form-container .form-row .form-column input,
.user-register-form-container .form-row .form-column select {
  padding: 8px;
  border-radius: 8px;
  border: 1px solid var(--color-border-gray);
  font-size: 12px;
  padding: 8px;
  font-family: "Lexend Deca", sans-serif;
  outline: none;
  width: 100%;
  color: var(--color-text-dark);
  font-weight: 400;
}

.user-register-form-container .form-row .form-column select {
  padding: 7px;
}

.user-register-form-container .form-row .form-column input:focus,
.user-register-form-container .form-row .form-column select:focus {
  border: 1px solid var(--color-blue-dark);
}

.user-register-form-container .form-row .form-column input::placeholder {
  color: var(--color-text-dark);
}

.user-register-form-container .form-row .form-column select option {
  color: var(--color-text-dark);
}

.user-register-form-container .form-row .form-column .label {
  width: 100%;
  display: block;
  margin-bottom: 15px;
  font-family: "Lexend Deca", sans-serif;
}

.user-register-form-container .form-row .form-column .form-column-aux {
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(50% - 15px);
}

.user-register-form-container .form-row .form-column .form-column-aux.aux {
  margin: 0px 30px 0px 0px;
}

.user-register-form-container .form-row .form-column .form-column-aux label {
  width: max-content;
}

.user-register-form-container
  .form-row
  .form-column
  .form-column-aux
  label.radio {
  font-weight: 400;
  font-size: 12px;
  display: inline-block;
  color: var(--color-text-dark);
}

.user-register-form-container
  .form-row
  .form-column
  .form-column-aux
  label
  input {
  width: max-content;
  margin: 0px 10px 0px 0px;
}

.user-register-form-container
  .form-row
  .form-column
  .form-column-aux.aux-radio {
  transform: translateY(7.5px);
}

.user-register-form-container .submit-button {
  margin-top: 25px;
  text-align: center;
}

.user-register-form-container .submit-button button {
  padding: 10px 60px;
  background-color: var(--color-blue-dark);
  color: var(--color-white-main);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bolder;
  font-size: 14px;
  font-family: "Poppins", sans-serif;
}

.user-register-form-container .submit-button button:hover {
  background-color: var(--color-blue-circle);
}

@media only screen and (max-width: 600px) {
  .user-register-form-container {
    width: 100%;
  }

  .user-register-form-container .form-row {
    display: flex;
    flex-direction: column;
    margin: 0px;
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% - 0px);
  }

  .user-register-form-container .form-row .form-column {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% - 0px);
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }

  .user-register-form-container .form-row .form-column .form-column-aux {
    display: flex;
    flex-direction: column;
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% - 0px);
  }

  .user-register-form-container .form-row .form-column .form-column-aux.aux {
    margin: 0px;
  }

  .user-register-form-container .form-row .form-column .label {
    margin: 15px 0px;
  }

  .user-register-form-container .form-row .form-column label {
    margin: 15px 0px;
  }

  .user-register-form-container
    .form-row
    .form-column
    .form-column-aux
    label
    input {
    width: max-content;
    margin: 0px 10px 0px 0px;
  }

  .user-register-form-container
    .form-row
    .form-column
    .form-column-aux.aux-radio {
    transform: translateY(0px);
  }
}


@media only screen and (min-width: 601px) and (max-width: 1024px) {
  .user-register-form-container {
    width: 100%;
  }

  .user-register-form-container .form-row {
    display: flex;
    margin: 0px;
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% - 25px);
  }

  .user-register-form-container .form-row .form-column {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 25px);
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }

  .user-register-form-container .form-row .form-column .form-column-aux {
    display: flex;
    flex-direction: column;
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 25px);
  }

  .user-register-form-container .form-row .form-column .form-column-aux.aux {
    margin: 0px;
  }

  .user-register-form-container .form-row .form-column .label {
    margin: 15px 0px;
  }

  .user-register-form-container .form-row .form-column label {
    margin: 15px 0px;
  }

  .user-register-form-container
    .form-row
    .form-column
    .form-column-aux
    label
    input {
    width: max-content;
    margin: 0px 10px 0px 0px;
  }

  .user-register-form-container
    .form-row
    .form-column
    .form-column-aux.aux-radio {
    transform: translateY(0px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/user-register/UserRegister.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,YAAY;EACZ,sCAAsC;EACtC,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;EAKE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;;;;;;EAME,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;EAC5B;;EAEA;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;;;;IAME,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;;;;IAIE,0BAA0B;EAC5B;AACF;;;AAGA;EACE;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;IACX,YAA2B;IAA3B,cAA2B;IAA3B,6BAA2B;EAC7B;;EAEA;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;;;;IAME,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;;;;IAIE,0BAA0B;EAC5B;AACF","sourcesContent":[".user-register-form-container {\n  width: 100%;\n  margin: 25px auto 0px;\n  padding: 25px;\n  border: 1px solid var(--color-border-gray);\n  border-radius: 8px;\n}\n\n.user-register-form-container h2 {\n  color: var(--color-text-dark);\n  margin-bottom: 25px;\n  font-family: \"Lexend Deca\", sans-serif;\n}\n\n.user-register-form-container .form-row {\n  display: flex;\n  justify-content: space-between;\n  flex: 0 0 calc(50% - 25px);\n  margin-bottom: 25px;\n}\n\n.user-register-form-container .form-row .form-column {\n  flex: 0 0 calc(50% - 25px);\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.user-register-form-container .form-row .form-column label {\n  width: 100%;\n  margin-bottom: 15px;\n  font-family: \"Lexend Deca\", sans-serif;\n  color: var(--color-text-dark);\n}\n\n.user-register-form-container .form-row .form-column input,\n.user-register-form-container .form-row .form-column select {\n  padding: 8px;\n  border-radius: 8px;\n  border: 1px solid var(--color-border-gray);\n  font-size: 12px;\n  padding: 8px;\n  font-family: \"Lexend Deca\", sans-serif;\n  outline: none;\n  width: 100%;\n  color: var(--color-text-dark);\n  font-weight: 400;\n}\n\n.user-register-form-container .form-row .form-column select {\n  padding: 7px;\n}\n\n.user-register-form-container .form-row .form-column input:focus,\n.user-register-form-container .form-row .form-column select:focus {\n  border: 1px solid var(--color-blue-dark);\n}\n\n.user-register-form-container .form-row .form-column input::placeholder {\n  color: var(--color-text-dark);\n}\n\n.user-register-form-container .form-row .form-column select option {\n  color: var(--color-text-dark);\n}\n\n.user-register-form-container .form-row .form-column .label {\n  width: 100%;\n  display: block;\n  margin-bottom: 15px;\n  font-family: \"Lexend Deca\", sans-serif;\n}\n\n.user-register-form-container .form-row .form-column .form-column-aux {\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 calc(50% - 15px);\n}\n\n.user-register-form-container .form-row .form-column .form-column-aux.aux {\n  margin: 0px 30px 0px 0px;\n}\n\n.user-register-form-container .form-row .form-column .form-column-aux label {\n  width: max-content;\n}\n\n.user-register-form-container\n  .form-row\n  .form-column\n  .form-column-aux\n  label.radio {\n  font-weight: 400;\n  font-size: 12px;\n  display: inline-block;\n  color: var(--color-text-dark);\n}\n\n.user-register-form-container\n  .form-row\n  .form-column\n  .form-column-aux\n  label\n  input {\n  width: max-content;\n  margin: 0px 10px 0px 0px;\n}\n\n.user-register-form-container\n  .form-row\n  .form-column\n  .form-column-aux.aux-radio {\n  transform: translateY(7.5px);\n}\n\n.user-register-form-container .submit-button {\n  margin-top: 25px;\n  text-align: center;\n}\n\n.user-register-form-container .submit-button button {\n  padding: 10px 60px;\n  background-color: var(--color-blue-dark);\n  color: var(--color-white-main);\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-weight: bolder;\n  font-size: 14px;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.user-register-form-container .submit-button button:hover {\n  background-color: var(--color-blue-circle);\n}\n\n@media only screen and (max-width: 600px) {\n  .user-register-form-container {\n    width: 100%;\n  }\n\n  .user-register-form-container .form-row {\n    display: flex;\n    flex-direction: column;\n    margin: 0px;\n    flex: 0 0 calc(100% - 0px);\n  }\n\n  .user-register-form-container .form-row .form-column {\n    flex: 0 0 calc(100% - 0px);\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n  }\n\n  .user-register-form-container .form-row .form-column .form-column-aux {\n    display: flex;\n    flex-direction: column;\n    flex: 0 0 calc(100% - 0px);\n  }\n\n  .user-register-form-container .form-row .form-column .form-column-aux.aux {\n    margin: 0px;\n  }\n\n  .user-register-form-container .form-row .form-column .label {\n    margin: 15px 0px;\n  }\n\n  .user-register-form-container .form-row .form-column label {\n    margin: 15px 0px;\n  }\n\n  .user-register-form-container\n    .form-row\n    .form-column\n    .form-column-aux\n    label\n    input {\n    width: max-content;\n    margin: 0px 10px 0px 0px;\n  }\n\n  .user-register-form-container\n    .form-row\n    .form-column\n    .form-column-aux.aux-radio {\n    transform: translateY(0px);\n  }\n}\n\n\n@media only screen and (min-width: 601px) and (max-width: 1024px) {\n  .user-register-form-container {\n    width: 100%;\n  }\n\n  .user-register-form-container .form-row {\n    display: flex;\n    margin: 0px;\n    flex: 0 0 calc(100% - 25px);\n  }\n\n  .user-register-form-container .form-row .form-column {\n    flex: 0 0 calc(50% - 25px);\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n  }\n\n  .user-register-form-container .form-row .form-column .form-column-aux {\n    display: flex;\n    flex-direction: column;\n    flex: 0 0 calc(50% - 25px);\n  }\n\n  .user-register-form-container .form-row .form-column .form-column-aux.aux {\n    margin: 0px;\n  }\n\n  .user-register-form-container .form-row .form-column .label {\n    margin: 15px 0px;\n  }\n\n  .user-register-form-container .form-row .form-column label {\n    margin: 15px 0px;\n  }\n\n  .user-register-form-container\n    .form-row\n    .form-column\n    .form-column-aux\n    label\n    input {\n    width: max-content;\n    margin: 0px 10px 0px 0px;\n  }\n\n  .user-register-form-container\n    .form-row\n    .form-column\n    .form-column-aux.aux-radio {\n    transform: translateY(0px);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
